(function () {
  'use strict';

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);
  }

  function updateBar(bar, cart) {
    if (!cart || typeof cart.total_price !== 'number') return;

    var threshold = Number(bar.getAttribute('data-threshold')) || 0;
    var total = cart.total_price;
    var state = total === 0 ? 1 : total < threshold ? 2 : 3;
    var text = bar.getAttribute('data-text-' + state) || '';
    var progress = 0;

    if (state === 2) {
      text = text.replaceAll('[rest]', formatMoney(Math.max(0, threshold - total)));
      progress = threshold > 0 ? Math.min(100, total / threshold * 100) : 100;
    } else if (state === 3) {
      progress = 100;
    }

    bar.setAttribute('data-state', String(state));
    bar.querySelector('[data-announcement-text]').textContent = text;
    bar.querySelector('[data-announcement-progress]').style.width = progress + '%';
  }

  function init() {
    var bars = document.querySelectorAll('[data-announcement-bar]');
    if (!bars.length) return;

    document.addEventListener('1a:cart:updated', function (event) {
      bars.forEach(function (bar) {
        updateBar(bar, event.detail);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
